export const normalizeColumnWidth = (width) => {
  if (width == null) return undefined;
  const parsed = typeof width === 'string' ? parseInt(width.replace('px', ''), 10) : width;
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const extractColumnWidths = (columns, previousWidths = {}) => {
  const next = { ...previousWidths };

  columns.forEach((column) => {
    if (!column?.accessor) return;
    const width = normalizeColumnWidth(column.width);
    if (width == null) return;
    next[column.accessor] = width;
  });

  return next;
};

export const applyColumnWidths = (columns, widths = {}) =>
  columns.map((column) => ({
    ...column,
    width: widths[column.accessor] ?? column.width ?? 240,
  }));
